declare const __APP_VERSION__: string | undefined

/**
 * Single source of truth for the Web App version
 */
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.103'

/**
 * Common known previous and current app versions for version selection
 */
export const KNOWN_APP_VERSIONS = [
  '0.0.103',
  '0.0.102',
  '0.0.101',
  '0.0.100',
  '0.0.99',
  '0.0.98',
  '0.0.97',
  '0.0.96',
  '0.0.95',
  '0.0.90',
  '0.0.80',
  '0.0.50',
  '0.0.26'
]
